import { RootState } from 'src/redux/createRootReducer'

// total available credit
export const selectTotalAvailableCreditLoadingFromState = (
  state: RootState,
): boolean => state.app.home.totalAvailableCredit.loading
export const selectTotalAvailableCreditCentsFromState = (
  state: RootState,
): number | undefined =>
  state.app.home.totalAvailableCredit.totalAvailableCreditCents
export const selectTotalAvailableCreditCentsUSDFromState = (
  state: RootState,
): number | null | undefined =>
  state.app.home.totalAvailableCredit.totalAvailableCreditCentsUSD
export const selectTotalAvailableCreditCentsCADFromState = (
  state: RootState,
): number | null | undefined =>
  state.app.home.totalAvailableCredit.totalAvailableCreditCentsCAD

// org stats
export const selectOrgStatsLoadingFromState = (state: RootState): boolean =>
  state.app.home.orgStats.loading
export const selectOrgStatsTotalFromState = (
  state: RootState,
): number | undefined => state.app.home.orgStats.total
export const selectOrgStatsOwnerFromState = (
  state: RootState,
): number | undefined => state.app.home.orgStats.owner
export const selectOrgStatsAdminFromState = (
  state: RootState,
): number | undefined => state.app.home.orgStats.admin
export const selectOrgStatsCardManagerFromState = (
  state: RootState,
): number | undefined => state.app.home.orgStats.cardManager
export const selectOrgStatsBookkeeperFromState = (
  state: RootState,
): number | undefined => state.app.home.orgStats.bookkeeper
export const selectOrgStatsMemberFromState = (
  state: RootState,
): number | undefined => state.app.home.orgStats.member
export const selectOrgStatsGuestFromState = (
  state: RootState,
): number | undefined => state.app.home.orgStats.guest
export const selectOrgStatsTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.home.orgStats.topLevelError
